
// components
import { IonListHeader, IonLabel, IonItem, } from '@ionic/vue';

export default {
  props: [ "title", "content", "isAccordionHeader", "size" ],
  components: { IonListHeader, IonLabel, IonItem, },
}
